import { action, makeAutoObservable } from "mobx";

export enum StatFormType {
  drawGraph = "drawGraph",
}

export enum FormDisplayType {
  popup = "popup",
  inline = "inline",
}

class GraphFormsStore {
  forms: {
    [StatFormType.drawGraph]: {
      type: FormDisplayType;
      open: boolean;
      init: {
        name?: string;
      };
    };
  } = {
    [StatFormType.drawGraph]: {
      type: FormDisplayType.popup,
      open: false,
      init: {},
    },
  };

  constructor() {
    makeAutoObservable(this);
  }

  @action
  showPopupForm(type: StatFormType) {
    this.forms[type].open = true;
    this.forms[type].type = FormDisplayType.popup;
  }

  @action
  closeForm(type: StatFormType) {
    this.forms[type].open = false;
  }
}

export default GraphFormsStore;
